import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteImages } from './CompleteImages';
import { ProjectNotificationsStatus } from '../../../../../notifications/gql/fragments/generated/ProjectNotificationsStatus';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CompleteProjectFragment = { __typename?: 'Project', id: string, archivedAt?: string | null, archivedFileCount?: number | null, deletedAt?: string | null, description?: string | null, fileCount: number, folderCount: number, ignoreArchive: boolean, insertedAt: string, isLoading?: boolean | null, isWorkfront?: boolean | null, lastUpdated: string, memberCount?: number | null, name: string, private: boolean, rootAssetId: string, storage: number, updatedAt?: string | null, workspaceId: string, notificationsEnabled?: boolean | null, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, accountId?: string | null, name: string, images?: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null } | null } | null };

export const CompleteProject = /*#__PURE__*/ gql`
    fragment CompleteProject on Project {
  id
  archivedAt
  archivedFileCount
  deletedAt
  description
  fileCount
  folderCount
  ignoreArchive
  images {
    ...CompleteImages
  }
  insertedAt
  isLoading @client
  isWorkfront
  lastUpdated
  memberCount
  name
  private
  rootAssetId
  storage
  updatedAt
  workspace {
    id
    accountId
    name
    images {
      ...CompleteImages
    }
  }
  workspaceId
  ...ProjectNotificationsStatus
}
    ${CompleteImages}
${ProjectNotificationsStatus}` as unknown as DocumentNode<CompleteProjectFragment, unknown>;

        

        
export const useCompleteProjectFragment = (
  input: string | Omit<UseFragmentOptions<CompleteProjectFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<CompleteProjectFragment>({
    fragment: CompleteProject,
    fragmentName: 'CompleteProject',
    ...options,
  });
};
  
        